import { orderBy, isEmpty } from 'lodash';

// eslint-disable-next-line import/prefer-default-export
export function getQuestionPage(state) {
  return state.questionPage || {};
}

export function getPageOptions(state, getters) {
  if (isEmpty(getters.getQuestionPage)) return [];

  return orderBy(getters.getQuestionPage.answers, ['id'], ['asc']);
}
